import { render, staticRenderFns } from "./hospitalView.vue?vue&type=template&id=731453ea&scoped=true"
import script from "./hospitalView.vue?vue&type=script&lang=js"
export * from "./hospitalView.vue?vue&type=script&lang=js"
import style0 from "./hospitalView.vue?vue&type=style&index=0&id=731453ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731453ea",
  null
  
)

export default component.exports